import { cloneDeep } from 'lodash';
import { Subject, Observable } from 'rxjs';

import { ControlDataModel, ControlEvent } from '../types/control.types';
import { ControlBroadCastEvent } from '../types';
import { RemoteDataSourceService } from '../services/remote-data-source.service';
import { DynamicFormCommonConfig, FormContentResponse } from 'zr-dynamic-form/dynamic-form-common';
import { DynamicFormDesignerConfig } from './dynamic-form-designer-config';
import { ShowHiddenRuleModel } from '../types/control-show-hidden.types';

/**
 * @description è¡¨åäºä»¶ç±»å
 *
 * @export
 * @enum {number}
 */
export enum DynamicFormEventType {
  BeforeLoad = 'beforeLoad',
  AfterLoad = 'afterLoad',
  BeforeDataLoad = 'beforeDataLoad',
  AfterDataLoad = 'afterDataLoad'
}

/**
 * æ§ä»¶å±äº«
 *
 */
export interface ControlShared {
  /**
   * æ¯å¦æ¯è®¾è®¡æ¶
   *
   */
  isDesign: boolean;

  globalData: any;
  /**
   * å¨å±dataå¼æ¹å
   *
   */
  globalDataChange: Observable<any>;

  /**
   *
   * åéå¨å±å¼æ¹å
   */
  sendGlobalDataChange(data: any): void;

  /**
   *
   * æ§ä»¶å¹¿æ­äºä»¶
   */
  controlBroadCasted$: Observable<ControlBroadCastEvent>;

  /**
   *
   * åéæ§ä»¶å¹¿æ­äºä»¶
   */
  controlBroadCasted(event: ControlBroadCastEvent): void;

  /**
   * è¿ç¨æ°æ®æºæå¡
   */
  remoteDataSourceService: RemoteDataSourceService;

  /**
   * éç¨éç½®
   */
  commonConfig: DynamicFormCommonConfig;
  /**
   * è®¾è®¡å¨éç½®
   */
  designerConfig: DynamicFormDesignerConfig;

  /**
   * è·åå·²åå¸è¡¨åcontent
   */
  getFormContent(formCode: string, labelCode: string): Observable<FormContentResponse>;
}

/**
 * @description è¡¨åäºä»¶
 *
 * @export
 */
export interface DynamicFormEvent {
  /**
   * @description åç»åç§°
   *
   * @memberof DynamicFormEvent
   */
  groupName: string;
  /**
   * @description åç§°
   *
   * @memberof DynamicFormEvent
   */
  name: DynamicFormEventType;
  /**
   * èæ¬ï¼æ¯æåçjsåjquery
   *
   * @memberof DynamicFormEvent
   */
  script: string;
  /**
   * @description æè¿°
   *
   * @memberof DynamicFormEvent
   */
  description?: string;
}

/**
 * @description å¨æè¡¨åmodel
 *
 * @export
 */
export interface DynamicFormModel {
  /**
   * è¡¨åmodel
   * @memberof DynamicFormModel
   */
  form: {
    /**
     * @description è¡¨åäºä»¶
     *
     */
    events: Array<DynamicFormEvent>;

    /**
     * æ¾éè§å
     */
    showHiddenRules?: Array<ShowHiddenRuleModel>;
  };
  /**
   * @description æ§ä»¶DataModel
   *
   * @memberof DynamicFormModel
   */
  controls: Array<ControlDataModel>;
}
/**
 * è½¬æ¢æè¡¨åmodel
 * @param val åå§æ°æ®
 */
export function toDynamicFormModel(val: any): DynamicFormModel {
  let model: DynamicFormModel = { form: { events: [] }, controls: [] };
  if (!val) {
    return model;
  }
  // æ§ççæ²¡æform å­æ®µ ï¼æä»¥è¦å¤æ­ä¸
  if (val[`form`]) {
    model = val;
  } else {
    model.controls = val;
    model.form.events = undefined;
  }
  return model;
}

/**
 * @description æ§è¡è¡¨åäºä»¶
 *
 * @export
 * @param  events è¡¨åäºä»¶éå
 * @param  eventType äºä»¶ç±»å
 * @param  thisArg The object to be used as the current object
 */
export function executeFormEvent(events: Array<DynamicFormEvent>, eventType: DynamicFormEventType, thisArg: any) {
  try {
    if (events) {
      const event = events.find((s) => s.name === eventType);
      if (event) {
        const func = new Function(event.script);
        func.call(thisArg);
      }
    }
  } catch (e) {
    console.warn(e);
  }
}

/**
 * è·åè¡¨åå¼ååå®¹
 *
 */
export function getDiffContent(originalContent: DynamicFormModel, newContent: DynamicFormModel): DynamicFormModel {
  const diffContent: DynamicFormModel = { form: { events: [] }, controls: [] };
  const formEvents = originalContent.form.events;
  for (let i = 0; i < formEvents.length; i++) {
    if (!equal(formEvents[i], newContent.form.events[i])) {
      diffContent.form.events.push(newContent.form.events[i]);
    }
  }

  // æ¾éè§åï¼ç´æ¥ç¨æ°ç
  // TODO æªæ¥åæ©å±ï¼è¡¨ååå¸åï¼æ¾éè§åæååï¼æ ç­¾ä¸­çä¹éè¦æå¨å»æ´æ°
  // æªæ¥å¯ä»¥ååå¹¶
  diffContent.form.showHiddenRules = newContent.form.showHiddenRules;

  diffControls(originalContent.controls, newContent.controls, diffContent.controls);

  return diffContent;
}

function diffControls(oldControls: ControlDataModel[], newControls: ControlDataModel[], diffs: ControlDataModel[]) {
  if (!newControls) {
    return;
  }
  oldControls.forEach((s) => {
    const newControl = newControls.find((p) => p.model.__identityCode === s.model.__identityCode);
    if (!newControl) {
      return;
    }
    let diff = diffControl(s, newControl);

    if (diff) {
      diff.model['__identityCode'] = s.model.__identityCode;
    } else {
      diff = { model: { __identityCode: s.model.__identityCode } } as ControlDataModel;
    }
    diffs.push(diff);
    diff.children = [];

    if (s.children && s.children.length > 0) {
      diffControls(s.children, newControl.children, diff.children);
    }
  });
}

function diffControl(oldControl: ControlDataModel, newControl: ControlDataModel): ControlDataModel {
  if (!newControl) {
    return null;
  }

  let isNew: boolean = false;
  const diff = { model: { validators: {} } } as ControlDataModel;

  const oldControlModelKeys = Object.getOwnPropertyNames(oldControl.model);
  // æ¯è¾ä¸¤ä¸ªcontrol
  for (const name of oldControlModelKeys) {
    if (name === 'events') {
      isNew = diffControlEvents(oldControl, newControl, diff) || isNew;
      continue;
    }
    if (name === 'validators') {
      isNew = diffControlValidators(oldControl, newControl, diff) || isNew;
      continue;
    }
    if (!equal(oldControl.model[name], newControl.model[name])) {
      isNew = true;
      diff.model[name] = newControl.model[name];
    }
  }

  // æ§çæ²¡æä¹æ¾è¿å»
  const addModelKeys = Object.getOwnPropertyNames(newControl.model).filter((s) => !oldControlModelKeys.includes(s));
  if (addModelKeys.length > 0) {
    addModelKeys.forEach((name) => {
      diff.model[name] = newControl.model[name];
    });

    isNew = true;
  }
  if (isNew) {
    return diff;
  }
  return null;
}

function diffControlEvents(oldControl: ControlDataModel, newControl: ControlDataModel, diff: any): boolean {
  let isNew: boolean = false;
  // å¤éåä¸å±
  const originalEvents = oldControl.model['events'] as ControlEvent[];
  const newEvents = newControl.model['events'] as ControlEvent[];
  if (!diff.model['events']) {
    diff.model['events'] = [];
  }
  const diffEvents = diff.model['events'];

  if (originalEvents && originalEvents.length >= 0) {
    originalEvents.forEach((event) => {
      const newEvent = newEvents.find((n) => n.name === event.name);
      if (!equal(event, newEvent)) {
        isNew = true;
        diffEvents.push(newEvent);
      }
    });
  }
  if (newEvents && newEvents.length >= 0) {
    // åäºä»¶ä¸å­å¨æèåäºä»¶ä¸åå«æ°ç
    const addEvents = newEvents.filter(
      (event) => !originalEvents || originalEvents.findIndex((oEvent) => oEvent.name === event.name) === -1
    );
    if (addEvents && addEvents.length > 0) {
      isNew = true;
      diffEvents.push(...addEvents);
    }
  }
  return isNew;
}

function diffControlValidators(oldControl: ControlDataModel, newControl: ControlDataModel, diff: any): boolean {
  let isNew: boolean = false;
  const originalValidators = oldControl.model.validators;
  if (!diff.model.validators) {
    diff.model.validators = {};
  }
  // æ·»å ä¿®æ¹äºç
  const newValidators = newControl.model.validators;
  for (const vName of Object.getOwnPropertyNames(originalValidators)) {
    if (!equal(originalValidators[vName], newValidators[vName])) {
      isNew = true;
      diff.model.validators[vName] = newValidators[vName];
    }
  }
  // æ·»å æ°å ç
  for (const vName of Object.getOwnPropertyNames(newValidators)) {
    if (!originalValidators[vName]) {
      isNew = true;
      diff.model.validators[vName] = newValidators[vName];
    }
  }
  return isNew;
}

/**
 * æ¯è¾æ¯å¦ç¸ç­ ä¼èªå¨å¿½ç¥å¯¹è±¡ä¸­å¼æ¯undefinedçå±æ§
 *
 * @returns
 */
function equal(oldObj: any, newObj: any) {
  if (typeof oldObj !== typeof newObj) {
    return false;
  }
  if (oldObj === newObj) {
    return true;
  }
  if (typeof oldObj === 'object') {
    const oldNames = Object.getOwnPropertyNames(oldObj).filter((s) => oldObj[s] !== undefined);
    const newNames = Object.getOwnPropertyNames(newObj).filter((s) => newObj[s] !== undefined);
    if (oldNames.length !== newNames.length) {
      return false;
    }
    for (let i = 0; i < oldNames.length; i++) {
      if (!equal(oldObj[oldNames[i]], newObj[oldNames[i]])) {
        return false;
      }
    }
    return true;
  }

  return JSON.stringify(oldObj) === JSON.stringify(newObj);
}

/**
 * åå¹¶è¡¨åcontent
 *
 */
export function mergeDiffContent(originalContent: DynamicFormModel, diffContent: DynamicFormModel): DynamicFormModel {
  const newContent: DynamicFormModel = {} as DynamicFormModel;
  newContent.form = { events: [] };
  newContent.controls = [];

  if (!diffContent) {
    return cloneDeep(originalContent);
  }

  // form
  if (!diffContent.form) {
    newContent.form = cloneDeep(originalContent.form);
  } else {
    // events
    if (!diffContent.form.events) {
      newContent.form.events = cloneDeep(originalContent.form.events);
    } else {
      const formEvents = originalContent.form.events;
      for (let i = 0; i < formEvents.length; i++) {
        if (diffContent.form.events[i]) {
          newContent.form.events[i] = diffContent.form.events[i];
        } else {
          newContent.form.events[i] = formEvents[i];
        }
      }
    }
    // showHiddenRules
    if (diffContent.form.showHiddenRules) {
      newContent.form.showHiddenRules = cloneDeep(diffContent.form.showHiddenRules);
    }
  }

  if (diffContent.controls && diffContent.controls.length > 0) {
    mergeControls(originalContent.controls, diffContent.controls, newContent.controls);
  } else {
    newContent.controls = cloneDeep(originalContent.controls);
  }
  return newContent;
}

function mergeControls(oldControls: ControlDataModel[], diffs: ControlDataModel[], newControls: ControlDataModel[]) {
  oldControls.forEach((s) => {
    if (!diffs) {
      diffs = [];
    }

    let diff = diffs.find((d) => {
      if (!d.model) {
        return false;
      }
      return d.model.__identityCode === s.model.__identityCode;
    });

    const merge = mergeControl(s, diff);
    newControls.push(merge);
    merge.children = [];
    merge.type = s.type;
    if (s.children && s.children.length > 0) {
      if (!diff) {
        diff = { children: [] } as ControlDataModel;
      }
      mergeControls(s.children, diff.children, merge.children);
    }
  });
}

function mergeControl(oldControl: ControlDataModel, diff: ControlDataModel): ControlDataModel {
  const newControl = { model: { validators: {} } } as ControlDataModel;

  if (!diff) {
    return cloneDeep(oldControl);
  }

  // åå¹¶control

  const oldControlModelKeys = Object.getOwnPropertyNames(oldControl.model);

  for (const name of oldControlModelKeys) {
    if (name === 'events') {
      if (!newControl.model['events']) {
        newControl.model['events'] = [];
      }
      mergeControlEvents(oldControl, newControl, diff);
      continue;
    }
    if (name === 'validators') {
      mergeControlValidators(oldControl, newControl, diff);
      continue;
    }
    if (diff.model[name] || diff.model[name] === 0 || diff.model[name] === false) {
      newControl.model[name] = diff.model[name];
    } else {
      newControl.model[name] = oldControl.model[name];
    }
  }
  // ææ§çæ²¡æä¹æ¾è¿å»
  const addModelKeys = Object.getOwnPropertyNames(diff.model).filter((s) => !oldControlModelKeys.includes(s));
  if (addModelKeys) {
    addModelKeys.forEach((name) => (newControl.model[name] = diff.model[name]));
  }

  return newControl;
}

function mergeControlEvents(oldControl: ControlDataModel, newControl: ControlDataModel, merge: any) {
  const originalEvents = oldControl.model['events'] as ControlEvent[];
  if (!newControl.model['events']) {
    newControl.model['events'] = [];
  }
  const newEvents = newControl.model['events'] as ControlEvent[];

  const mergeEvents = merge.model['events'] as ControlEvent[];
  if (!mergeEvents) {
    newControl.model['events'] = cloneDeep(originalEvents);
    return;
  }

  if (originalEvents && originalEvents.length >= 0) {
    originalEvents.forEach((event) => {
      const newEvent = mergeEvents.find((n) => n.name === event.name);
      newEvents.push(newEvent);
    });
  }
  if (mergeEvents && mergeEvents.length >= 0) {
    // åäºä»¶ä¸å­å¨æèåäºä»¶ä¸åå«æ°ç
    const addEvents = mergeEvents.filter(
      (event) => !originalEvents || originalEvents.findIndex((oEvent) => oEvent.name === event.name) === -1
    );
    if (addEvents && addEvents.length > 0) {
      newEvents.push(...addEvents);
    }
  }
}

function mergeControlValidators(oldControl: ControlDataModel, newControl: ControlDataModel, merge: any) {
  const originalValidators = oldControl.model.validators;
  const mergeValidators = merge.model.validators;
  Object.assign(newControl.model.validators, originalValidators, mergeValidators);
}
